import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata meie laokaupade pakkumisi - viimased tooted kiire tarnega!

  <span style="color:#85c1dc;">**FI:**</span>
  Liity ON24.fi verkkokauppaan ja lahjoitamme sinulle 100 € ON24 rahaa.

  <span style="color:#85c1dc;">**RU:**</span>
  Присоединяйтесь к интернет-магазину ON24.ee и получите в подарок 100 € денег ON24.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1925 = msg(
  mf`Vaata meie laokaupade pakkumisi - viimased tooted kiire tarnega!`,
  mf`Liity ON24.fi verkkokauppaan ja lahjoitamme sinulle 100 € ON24 rahaa.`,
  mf`Присоединяйтесь к интернет-магазину ON24.ee и получите в подарок 100 € денег ON24.`,
)

export { m1925 as 'w.basket.empty.third.title' }